import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { api } from '../../../../services/api'

export function useItensPedido() {
  const { id: paramNumNota } = useParams()
  const [numNota, setNumNota] = useState(paramNumNota || '')
  const [isSearching, setIsSearching] = useState(false)
  const toast = useToast()

  useEffect(() => {
    if (paramNumNota) {
      setNumNota(paramNumNota)
      setTimeout(() => {
        refetch()
      }, 300)
    }
  }, [paramNumNota])

  const {
    data: pedidoData,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  } = useQuery(
    ['pedido-itens', numNota],
    async () => {
      if (!numNota) return null
      const response = await api.get(`/ordem-producao/listar-status/${numNota}`)
      return response.data
    },
    {
      enabled: false,
      retry: 1,
      staleTime: 1000 * 60 * 5, // 5 minutos
      onSuccess: () => {
        setIsSearching(false)
      },
      onError: () => {
        setIsSearching(false)
        toast({
          title: 'Erro na busca',
          description: error?.response?.data?.message || 'Não foi possível buscar os dados do pedido',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      },
    }
  )

  const handleSearch = async () => {
    if (!numNota) return
    setIsSearching(true)
    refetch()
  }

  const getStatusColor = (status) => {
    const statusColors = {
      'SAIU PRA COMPRA': 'orange',
      RECEBIMENTO: 'yellow',
      'INICIO DESEMBALAGEM': 'blue',
      'TROCA SOLICITADA': 'red',
      'TROCA CONCLUIDA': 'green',
      'FINALIZAÇÃO DESEMBALAGEM': 'cyan',
      'APROVAÇÃO PILOTO': 'purple',
      'INICIO PERSONALIZAÇÃO': 'teal',
      'TERMINO DE PERSONALIZAÇÃO': 'teal',
      FINALIZAÇÃO: 'green',
      'EMISSÃO NOTA': 'pink',
      'GERAR ETIQUETA': 'orange',
      'SAIU ENTREGA': 'blue',
      'PRONTO PRA ENTREGA': 'green',
      ENTREGUE: 'purple',
      'GEROU OP': 'gray', // este é o alias, use se necessário
    }

    return statusColors[status] || 'gray'
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return 'Não informado'
    try {
      const date = new Date(dateStr)
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    } catch (e) {
      return dateStr
    }
  }

  return {
    numNota,
    setNumNota,
    pedidoData,
    isLoading,
    isError,
    error,
    isFetching,
    isSearching,
    handleSearch,
    getStatusColor,
    formatDate,
  }
}
